/**
 * Route configuration constants
 */

export const ROUTES = {
  // Public routes
  HOME: '/',
  LOGIN: '/login',
  SIGNUP: '/auth/sign-up',
  FORGOT_PASSWORD: '/auth/forgot-password',
  RESET_PASSWORD: '/reset-password',
  PRIVACY_POLICY: '/privacy-policy',

  // Register routes (from invitation)
  REGISTER_USER: '/users/register-user',
  ACCEPT_INVITATION: '/accept-invitation',
  REJECT_INVITATION: '/reject-invitation',

  // Workspace invitation routes (from email)
  WORKSPACE_INVITATION_ACCEPT: '/workspace-invitation/accept',
  WORKSPACE_INVITATION_REJECT: '/workspace-invitation/reject',

  // Protected routes
  PROFILE: '/profile',
  NOTIFICATION: '/notification',

  // Workspace routes
  WORKSPACE: '/w/:workspaceSlug',
  WORKSPACE_PROJECTS: '/w/:workspaceSlug/projects',
  WORKSPACE_PROJECTS_NEW: '/w/:workspaceSlug/projects/new',
  WORKSPACE_PROJECT: '/w/:workspaceSlug/p/:projectKey',
  WORKSPACE_PROJECT_BOARD: '/w/:workspaceSlug/p/:projectKey/board',
  WORKSPACE_PROJECT_BACKLOG: '/w/:workspaceSlug/p/:projectKey/backlog',
  WORKSPACE_PROJECT_TIMELINE: '/w/:workspaceSlug/p/:projectKey/timeline',
  WORKSPACE_PROJECT_SPRINTS: '/w/:workspaceSlug/p/:projectKey/sprints',
  WORKSPACE_PROJECT_SETTINGS: '/w/:workspaceSlug/p/:projectKey/settings',
  WORKSPACE_PROJECT_CALENDAR: '/w/:workspaceSlug/p/:projectKey/calendar',
  WORKSPACE_PROJECT_REPORTS: '/w/:workspaceSlug/p/:projectKey/reports',
  WORKSPACE_ISSUE: '/w/:workspaceSlug/issues/:issueKey',
  WORKSPACE_SETTINGS: '/w/:workspaceSlug/settings',
  WORKSPACE_MEMBERS: '/w/:workspaceSlug/members',

  // Admin routes
  ADMIN_DASHBOARD: '/admin',
  ADMIN_SUBSCRIPTIONS: '/admin/subscriptions',

  // Fallback
  NOT_FOUND: '*',
} as const;

export type RouteKey = keyof typeof ROUTES;

/**
 * Routes that don't require authentication
 */
export const PUBLIC_ROUTES: string[] = [
  ROUTES.HOME,
  ROUTES.LOGIN,
  ROUTES.SIGNUP,
  ROUTES.FORGOT_PASSWORD,
  ROUTES.RESET_PASSWORD,
  ROUTES.PRIVACY_POLICY,
  ROUTES.REGISTER_USER,
  ROUTES.ACCEPT_INVITATION,
  ROUTES.REJECT_INVITATION,
  ROUTES.WORKSPACE_INVITATION_ACCEPT,
  ROUTES.WORKSPACE_INVITATION_REJECT,
];

/**
 * Routes that require authentication
 */
export const PROTECTED_ROUTES: string[] = [
  ROUTES.PROFILE,
  ROUTES.NOTIFICATION,
  ROUTES.WORKSPACE,
  ROUTES.WORKSPACE_PROJECTS,
  ROUTES.WORKSPACE_PROJECTS_NEW,
  ROUTES.WORKSPACE_PROJECT,
  ROUTES.WORKSPACE_PROJECT_BOARD,
  ROUTES.WORKSPACE_PROJECT_BACKLOG,
  ROUTES.WORKSPACE_PROJECT_TIMELINE,
  ROUTES.WORKSPACE_PROJECT_SPRINTS,
  ROUTES.WORKSPACE_PROJECT_SETTINGS,
  ROUTES.WORKSPACE_PROJECT_CALENDAR,
  ROUTES.WORKSPACE_PROJECT_REPORTS,
  ROUTES.WORKSPACE_ISSUE,
  ROUTES.WORKSPACE_SETTINGS,
  ROUTES.WORKSPACE_MEMBERS,
];

/**
 * Default redirect after login
 */
export const DEFAULT_AUTHENTICATED_ROUTE = '/dashboard';

/**
 * Default redirect when not authenticated
 */
export const DEFAULT_UNAUTHENTICATED_ROUTE = ROUTES.LOGIN;

export default ROUTES;
